"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeTrigger = void 0;
const mobx_1 = require("mobx");
const index_1 = require("../index");
/**
 * Mobx Trigger
 *
 * This can be used to force a mobx autorun to cause the autorun to re-run
 *
 */
class IkeTrigger {
    constructor(name) {
        this.timeout = null;
        /** Report that the trigger has changed causing the autorun to fire */
        this.run = () => {
            if (this.isTriggering) {
                this.timeout = null;
            }
            this.atom.reportChanged();
        };
        this.atom = (0, mobx_1.createAtom)(`trigger: ${name} `);
    }
    /** Wether the trigger is scheduled to run */
    get isTriggering() {
        return this.timeout != null;
    }
    /** Observe the trigger, generally used inside of a autorun */
    observe() {
        this.atom.reportObserved();
    }
    /** Schedule the trigger to run on the next animation frame*/
    trigger() {
        if (this.isTriggering) {
            return;
        }
        this.timeout = index_1.Services.Window.window.requestAnimationFrame(this.run);
    }
}
exports.IkeTrigger = IkeTrigger;
//# sourceMappingURL=trigger.js.map